import { Sheet, SheetContent } from "@/components/ui/sheet";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { InviteOrEditPersonContent } from "./InviteOrEditPersonContent";
import { EmployeeFormSchema } from "../forms/Forms";
import { UserRole } from "@common/utils/graphql";
import { useRecoilValue } from "recoil";
import { roleState } from "@common/state/roleState";
import { useUserStore } from "@domains/auth/utils/useUserStore";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onBack: () => void;
}

export const InvitePersonSheet = ({ isOpen, onBack, onClose }: Props) => {
  const role = useRecoilValue(roleState);
  const { employeeId, departmentId: depId } = useUserStore((state) => state);
  let managerEmployeeProfileId = undefined;
  let departmentId = undefined;

  // When a manager is inviting a person, set them as peron's default manager
  if (role === UserRole.Manager) {
    managerEmployeeProfileId = employeeId || undefined;
    departmentId = depId ? `${depId}` : undefined;
  }

  const form = useForm<z.infer<typeof EmployeeFormSchema>>({
    resolver: zodResolver(EmployeeFormSchema),
    defaultValues: {
      roles: [UserRole.Employee],
      managerEmployeeProfileId,
      departmentId,
    },
  });

  const handleClose = () => {
    form.reset();
    onClose();
  };

  const handleBack = () => {
    form.reset();
    onBack();
  };
  return (
    <Sheet open={isOpen}>
      <SheetContent onClose={handleClose}>
        <InviteOrEditPersonContent form={form} onBack={handleBack} />
      </SheetContent>
    </Sheet>
  );
};
